export default `${process.env.REACT_APP_API_DOMAIN || "http://localhost:8000" }/v1`;